var borders = {
  none: 0,
  "1px": "1px solid",
  "2px": "2px solid",
  "4px": "4px solid"
};
export default borders;
//# sourceMappingURL=borders.js.map